'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillers = undefined;
var _serviceHelpers = require('./serviceHelpers');
var getFulfillers = exports.getFulfillers = function getFulfillers(accessToken, env) {
  return (0, _serviceHelpers.callFetch)('fulfillerIdentityUrl', 'GET', 'v1/fulfillers', null, accessToken, env).then(function (response) {
    return response.map(function (v) {
      return {
        name: v.name,
        fulfillerId: v.fulfillerId,
        internalFulfillerId: v.internalFulfillerId
      };
    });
  });
};